export const COMPLAINT_ROUTE =
  'tachograf/zloz-reklamacje-karty-do-tachografu-i-uzyskaj-karte-zastepcza';
export const STC_COMPLAINT_APPLICATION_ROUTE = 'reklamacje';
